/* ATLAS runtime: reveal, product forms, sticky add-to-cart, mobile nav.
   The cart drawer lives in assets/atlas-cart.js and is reached through
   window.AtlasCart, which loads first (both scripts are deferred, so order
   is preserved). Guarded so a duplicate script tag is harmless. */
(function () {
  'use strict';
  if (window.__atlasInit) return;
  window.__atlasInit = true;

  var RM = window.matchMedia('(prefers-reduced-motion: reduce)');
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* 1. Reveal.
     The visible end state is guaranteed by CSS: .at-r runs an animation with
     fill-mode both whose last keyframe is opacity 1. This observer only adds
     the will-change hint while an element is priming. If it never runs -- no
     IntersectionObserver, script blocked, screenshot tooling -- nothing stays
     hidden. That was a real defect once: 30 elements were invisible whenever
     the observer did not fire. */
  function initReveal() {
    var els = $$('.at-r');
    if (!els.length) return;
    if (RM.matches || !('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('at-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        el.classList.add('at-priming');
        el.classList.add('at-in');
        el.addEventListener('transitionend', function done() {
          el.classList.remove('at-priming');
          el.removeEventListener('transitionend', done);
        });
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* 2. Product forms -> add to cart -> open the drawer.
     Without JS the form posts normally to /cart/add and Shopify redirects to
     the cart page, so buying still works with scripting off.
     Double submit is blocked two ways: a per-form in-flight flag, and the
     drawer's own busy state. */
  function initForms() {
    $$('form[data-atlas-product-form]').forEach(function (form) {
      var inflight = false;
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return;                 // let it post normally
        e.preventDefault();
        if (inflight) return;
        inflight = true;

        var btn = form.querySelector('[type="submit"]');
        var live = $('[data-atlas-live]');
        var label = btn ? btn.textContent : '';
        if (btn) {
          btn.setAttribute('aria-disabled', 'true');
          btn.setAttribute('disabled', 'disabled');
          btn.textContent = 'Adding…';
        }
        if (window.AtlasCart) window.AtlasCart.error('');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            if (!res.ok) {
              var msg = res.j.description || res.j.message || 'This item could not be added.';
              if (window.AtlasCart) { window.AtlasCart.error(msg); window.AtlasCart.open(); }
              if (live) live.textContent = msg;
              return;
            }
            if (live) live.textContent = 'Added to bag.';
            if (window.AtlasCart) return window.AtlasCart.refresh().then(window.AtlasCart.open);
          })
          .catch(function () {
            if (window.AtlasCart) { window.AtlasCart.error('Something went wrong. Please try again.'); window.AtlasCart.open(); }
          })
          .then(function () {
            inflight = false;
            if (btn) {
              btn.removeAttribute('aria-disabled');
              btn.removeAttribute('disabled');
              btn.textContent = label;
            }
          });
      });
    });
  }

  /* 3. Sticky add-to-cart (mobile). Appears once the hero CTA has left the
     viewport, hides again while the offer CTA is on screen. */
  function initSticky() {
    var bar = $('[data-atlas-satc]');
    if (!bar) return;
    var heroCta = $('[data-atlas-hero-cta]');
    var offerCta = $('[data-atlas-offer-cta]');
    if (!heroCta || !('IntersectionObserver' in window)) return;

    var heroOut = false, offerIn = false;
    var apply = function () { bar.classList.toggle('at-satc--on', heroOut && !offerIn); };
    new IntersectionObserver(function (es) { heroOut = !es[0].isIntersecting; apply(); },
      { threshold: 0 }).observe(heroCta);
    if (offerCta) {
      new IntersectionObserver(function (es) { offerIn = es[0].isIntersecting; apply(); },
        { threshold: 0 }).observe(offerCta);
    }
  }

  /* 4. Mobile nav. */
  function initNav() {
    var t = $('[data-atlas-nav-toggle]');
    var n = $('[data-atlas-nav]');
    if (!t || !n) return;
    t.addEventListener('click', function () {
      var open = n.classList.toggle('at-is-open');
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function boot() { initReveal(); initForms(); initSticky(); initNav(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
